import { z } from 'zod/v4';

import { columns, columnValidators } from './columns';

export const lastTransactionAgeAdjustmentSchema = z.object(columns);

export type LastTransactionAgeAdjustment = z.output<
  typeof lastTransactionAgeAdjustmentSchema
>;

export const lastTransactionAgeAdjustmentUpdateSchema =
  z.object(columnValidators);

export type LastTransactionAgeAdjustmentUpdate = z.output<
  typeof lastTransactionAgeAdjustmentUpdateSchema
>;
